<template>
  <div v-if="parentEntity" class="mt-3">
    <right-panel class="float-right" id="sidebar-new-process" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>

    <right-panel class="float-right" id="sidebar-info-process" width="800px">
      <div class="pl-5 pr-5" v-if="infoItem">
        <h3 class="mb-5">
          <i class="bx bx-info-circle align-middle font-size-24 mr-2"></i>
          <span class="  text-primary">{{ infoItem.name | translate }}</span>

          {{ $t("process.info") }}
        </h3>

        <content-loading v-if="isInfoLoading" />
        <div v-else>
          <h5>{{ $t("process.used-places") }}</h5>
          <table v-if="info.docs.length > 0" class="table table-border table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th>{{ $t("department.parent") }}</th>
                <th>{{ $t("department.text") }}</th>
                <th class="text-center">{{ $t("common.edit") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in info.docs" :key="'info' + i._id">
                <td>
                  {{ i.parent ? $options.filters.translate(i.parent.name) : "-" }}
                </td>

                <td>
                  {{ i.name | translate }}
                </td>
                <td style="text-align: center;">
                  <a href="javascript:;void(0);" @click="deleteByIdFromHierarchy(i)" v-b-tooltip.hover :title="$t('common.delete')">
                    <i class="bx bx-trash-alt text-danger"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <empty v-else width="200px">
            <h6 class="text-center">{{ $t("common.no-hierarchy") }}</h6>
          </empty>
        </div>
        <!-- Begin: Pagination -->

        <div v-if="info" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="infoRequest.options.page" :total-rows="info.totalDocs" :per-page="info.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->
      </div>
    </right-panel>

    <!-- Begin : Inventory -->
    <template>
      <right-panel class="float-right" id="sidebar-process-inventory" width="1400px" icon="" @hidden="bulkUpdateRightPanelClosed">
        <!-- TKP-128: girilmiş kayıtlar + toplu güncelleme. TKP-182 md.82: iki sekme panelin kendisinde (TKP-173) — dış sekme çubuğu kalktı. -->
        <HierarchyInventoryView v-if="selectedBox" :department="parentEntity" :process="selectedBox" :reload="inventoryReload" data-test="process-inventory-view" />
      </right-panel>
      <!-- TKP-27 / 6.1 kriter 3: ilgili kişileri sürecin tüm verilerine ata -->
      <right-panel class="float-right" id="sidebar-process-bulk-datasubject" width="700px" icon="">
        <div class="pl-5 pr-5" v-if="selectedBox">
          <BulkDatasubjectForm :process="selectedBox" @onAssigned="onBulkDatasubjectAssigned" />
        </div>
      </right-panel>
      <!-- TKP-178 md.48: ilgili kişileri sürecin tüm verilerinden kaldır / değiştir -->
      <right-panel class="float-right" id="sidebar-process-bulk-remove" width="700px" icon="">
        <div class="pl-5 pr-5" v-if="selectedBox">
          <BulkRemoveForm :process="selectedBox" @onRemoved="onBulkDatasubjectAssigned" />
        </div>
      </right-panel>
    </template>
    <!-- End : Inventory -->
    <div class="ds-card">
      <div class="ds-card--title justify-content-between">
        <span>
          <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
          <span v-html="$t('process.owned-list', { name: $options.filters.translate(parentEntity.name) })"> </span>
        </span>

      </div>
      <div>
        <div class="search2  mb-4" style=" width: 18.50rem;">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination" class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in pagination.docs" :key="item._id" :id="'popover-target-' + item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
          <div class="actions d-flex justify-content-end p-2" style="top:0">
            <div class="action" @click="redirectToRelatedFiles(item)" v-on:click.stop v-b-tooltip.hover :title="$t('file-manager.view-related-files')">
              <i class="iconoir-page"></i>
            </div>
          </div>
          <div class="text">{{ item.name | translate }}<draft-badge entity-type="PROCESS" :entity-id="item._id" /></div>
          <div class="actions d-flex justify-content-center">
            <div class="action" v-if="hasRemovePermission" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
              <i class="iconoir-trash"></i>
            </div>
            <div class="action" v-if="hasUpdatePermission" @click="markAsComplete(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.completed')">
              <i :class="item.completed ? 'iconoir-check-circle' : 'iconoir-circle'"></i>
            </div>
            <!-- TKP-241 p.8: organizasyon geneli bilgi — Birim / Süreç Yöneticisi görmez -->
            <div v-if="currentAccountCan('ENTITY_PROCESS_USED_PLACES__CAN_VIEW')" class="action" data-test="process-used-places" @click="fetchInfo(item.process)" v-on:click.stop v-b-toggle="'sidebar-info-process'" v-b-tooltip.hover :title="$t('process.used-places')">
              <i class="iconoir-info-circle"></i>
            </div>

            <div class="action" @click="edit(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.edit')">
              <i class="iconoir-edit-pencil"></i>
            </div>
            <div class="action" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
            <!-- TKP-200 m.18: onay açıkken de görünür — form eklemeyi düğüm başına taslağa yazar -->
            <div class="action" data-test="bulk-datasubject-action" @click="showBulkDatasubjectPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('process-data.bulk-datasubject')">
              <i class="iconoir-group"></i>
            </div>
            <!-- TKP-242 q.4: onay açıkken de görünür — form kaldırma/değiştirmeyi taslağa yazar (arka planda) -->
            <div class="action" data-test="bulk-remove-action" @click="showBulkRemovePanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('process-data.bulk-remove.action')">
              <i class="iconoir-user-xmark"></i>
            </div>
          </div>

          <b-popover :target="'popover-target-' + item._id" triggers="hover" placement="bottom" variant="secondary">
            <template #title> {{ $t("process.admins") }}</template>
            <table>
              <tr v-for="admin in item.admins" :key="'process-admin' + admin._id">
                <td><letter-avatar :name="admin.account.name" :image="admin.account.avatar" variant="secondary" /></td>
                <td class="text-center">{{ admin.account.name }}</td>
              </tr>
              <tr v-if="!item.admins || item.admins.length < 1">
                <span>
                  <b>
                    {{ $t("process.no-admin") }}
                  </b>
                </span>
              </tr>
            </table>
          </b-popover>
        </div>

        <!-- TKP-189: taslağımdaki yeni süreçler (gerçek ya da gölge birimin altında) — seçilebilir gölge kart; TKP-200 m.19: envanter özellikleri eylemi -->
        <div v-for="item in shadowProcesses" :key="'shadow-' + item._id" class="ds-card--item" style="opacity: .85; border-style: dashed;" :class="selectedBoxStyle(item)" data-test="shadow-process" @click="selectBox(item)">
          <div class="text">
            {{ item.name | translate }}
            <b-badge variant="info" class="ml-1"><i class="bx bx-edit"></i> {{ $t(draftBadgeKey(item)) }} · {{ $t("approval.new-record") }}</b-badge>
          </div>
          <!-- TKP-200 m.19: taslak süreçte de envanter özellikleri (panel ağacı taslaktan kurulur, yazımlar taslağa) -->
          <div class="actions d-flex justify-content-end p-2" style="top:0">
            <div class="action" data-test="shadow-process-inventory" @click="showInventoryPanel(item)" v-on:click.stop v-b-tooltip.hover :title="$t('inventory.filter.inventory-features')">
              <i class="iconoir-network-right"></i>
            </div>
          </div>
        </div>

        <div class="ds-card--item2" @click="openRightPanel">
          <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
    </div>
  </div>
</template>

<script>
import BulkLock from "@/modules/approval/bulk-lock"; // TKP-130
import DraftBadge from "@/modules/approval/draft-badge"; // TKP-104
import { completeBlocked } from "@/modules/approval/approval"; // TKP-241 p.6
import { draftBadgeKey, shadowProcessesOf } from "@/modules/approval/draft-overlay"; // TKP-189
import HierarchyInventoryView from "@modules/inventory/component/hierarchy/hierarchy-inventory-view";
import BulkDatasubjectForm from "@modules/process-data/component/process-datasubject-bulk-form";
import BulkRemoveForm from "@modules/process-data/component/process-datasubject-bulk-remove-form"; // TKP-178 md.48
import Form from "../../department-process/organization-department-process-form";

export default {
  mixins: [BulkLock],
  components: { DraftBadge, Form,
    HierarchyInventoryView, BulkDatasubjectForm, BulkRemoveForm },
  data() {
    return {
      inventoryReload: 0,
      request: {
        options: { page: 1, limit: 17, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      libraryScopedState: "process",

      infoRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  computed: {
    // TKP-189: seçili (gerçek ya da gölge) birimin altında kendi taslağımdaki yeni süreçler
    shadowProcesses() {
      return this.parentEntity ? shadowProcessesOf((this.$store.getters || {})["approval/drafts"], this.parentEntity, this.currentAccount && this.currentAccount._id) : [];
    },
    parentEntity() {
      return this.$store.getters["entityBoxes/department"];
    },
    pagination() {
      return this.$store.getters["organizationDepartmentProcess/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDepartmentProcess/isLoading"];
    },

    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },

    infoItem() {
      return this.$store.getters["organizationProcess/infoItem"];
    },
    info() {
      return this.$store.getters["organizationProcess/info"];
    },
    isInfoLoading() {
      return this.$store.getters["organizationProcess/isInfoLoading"];
    },
    selectedBox() {
      return this.$store.getters["entityBoxes/process"];
    },
  },
  watch: {
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    parentEntity(item) {
      this.debounce(() => this.paginate());
    },

    infoRequest: {
      deep: true,
      immediate: false,
      handler() {
        this.debounce(() => this.fetchInfo());
      },
    },
  },
  mounted() {},
  methods: {
    draftBadgeKey, // TKP-189
    async handleNameFilterChanged(n, o) {
      this.$store.commit("entityBoxes/clearFrom", "process");
      this.$store.commit("organizationDepartmentProcess/selectedEntity", undefined);

      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedProcess = this.$store.getters["entityBoxes/process"];
        if (selectedProcess) {
          await this.selectBox(selectedProcess);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    redirectToRelatedFiles(item) {
      const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
      this.$router.push({ path: url, query: { process: item._id, processName: item.name?.[this.currentLanguage] } });
    },
    showBulkRemovePanel(item) {
      this.$store.commit("entityBoxes/process", item);
      this.$store.commit("organizationDepartmentProcess/selectedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-process-bulk-remove");
    },
    showBulkDatasubjectPanel(item) {
      this.$store.commit("entityBoxes/process", item);
      this.$store.commit("organizationDepartmentProcess/selectedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-process-bulk-datasubject");
    },
    onBulkDatasubjectAssigned() {
      // seçili düğümün ilgili kişi kutusu yenilensin
      const node = this.$store.getters["entityBoxes/data"];
      if (node) this.$store.dispatch("organizationProcessDataDatasubject/paginate", { options: { page: 1, limit: 13 }, query: { processData: { value: { _id: node._id }, isObject: true } } });
    },
    async showInventoryPanel(item) {
      this.$store.commit("entityBoxes/process", item);
      this.$store.commit("organizationDepartmentProcess/selectedEntity", item);

      this.$store.commit("inventoryFilter/clear");
      this.$store.commit("inventoryFilter/department", item.department);
      this.$store.commit("inventoryFilter/process", item);

      this.inventoryReload++; // TKP-128: panel her açılışta güncel kayıtları çeksin
      this.$root.$emit("bv::toggle::collapse", "sidebar-process-inventory");
    },

    selectedBoxStyle(item) {
      let style = "";
      if (this.selectedBox?._id == item._id) {
        style = "bg-main text-white";
      } else if (item.completed) {
        style += " completed";
      }
      return style;
    },

    async paginate() {
      if (!this.parentEntity) {
        return;
      }
      const request = { ...this.request };
      request.query = {
        ...request.query,
        department: { value: { _id: this.parentEntity._id }, isObject: true },
      };

      await this.$store.dispatch("organizationDepartmentProcess/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDepartmentProcess/delete", item._id);
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    interceptForSetParent(payload) {
      payload.department = this.parentEntity;
    },

    async deleteByIdFromHierarchy(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDepartmentProcess/delete", item.rel_id);
        this.$toast.success(this.$t("common.delete-successful"));
        this.fetchInfo();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.delete-failed") });
      }
    },

    async markAsComplete(item) {
      // TKP-241 p.6: taslaktaki kayıt tamamlandı işaretlenemez; değilse taslağa yazılmadan doğrudan işaretlenir
      if (completeBlocked((this.$store.getters || {})["approval/drafts"], "PROCESS", item, this.currentAccount && this.currentAccount._id)) {
        this.$toast.warning(this.$t("approval.complete-has-drafts"));
        return;
      }
      try {
        await this.$store.dispatch("organizationDepartmentProcess/markAsComplete", item._id);
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    edit(item) {
      this.$store.commit("organizationDepartmentProcess/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-process");
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.commit("organizationDepartmentProcess/editedEntity");
      this.$store.commit("organizationDepartmentProcess/copingEntity");
      // this.$store.dispatch("organizationDepartmentProcess/resetForm");
    },
    bulkUpdateRightPanelClosed() {
      this.$store.commit("inventoryFilter/clear");
    },

    selectBox(item) {
      this.$store.dispatch("entityBoxes/selectProcess", item);
    },

    fetchInfo(item) {
      if (!item) {
        item = this.infoItem;
      }
      this.$store.dispatch("organizationProcess/fetchInfo", { item, pagination: this.infoRequest });
    },

    copyToForm(item) {
      this.$store.commit(`organizationDepartmentProcess/copingEntity`, { ...item, libraryItem: item, _id: undefined, department: this.parentEntity });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-process");
    },

    openRightPanel() {
      const department = this.$store.getters["entityBoxes/department"];
      this.$store.commit(`organizationDepartment/selectedEntity`, department);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-process");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../organization-entities-view.scss");
</style>
